import { withChartLayout } from 'components/common';
import HamiltonAnxietyRatingScale from 'components/features/chart/special-charts/hamilton-anxiety-rating-scale/HamiltonAnxietyRatingScale';

const HamiltonAnxietyRatingScalePage = withChartLayout('Hamilton Anxiety Rating Scale')(HamiltonAnxietyRatingScale);
export default HamiltonAnxietyRatingScalePage;
